var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'参加中の複数のイベントを見る方法'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("\n          イベントは主催者ごとのグループに表示されます。"),_c('br'),_c('br'),_vm._v("\n          左スライドメニューからグループを切り替えることで参加中のイベントを確認することができます。\n        ")])])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36e3eaf3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help36.vue
// module id = v2ec
// module chunks = 0